import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { PanicAlertTopicRequest } from "../shared/panic-alert-topic-request";
import { DataService_TopicMaintenance } from "../shared/data.service";

@Component({
	selector: "app-panic-alert-topic-modify",
	templateUrl: "./panic-alert-topic-modify.component.html",
	styleUrls: ["./panic-alert-topic-modify.component.css"],
})
export class PanicAlertTopicModifyComponent implements OnInit {
	constructor(
		private dialogConfig: DynamicDialogConfig,
		private ref: DynamicDialogRef,
		private confirmationService: ConfirmationService,
		private dataService: DataService_TopicMaintenance
	) {}

	ngOnInit(): void {
		this.EditMode = this.dialogConfig.data.EditMode;
		this.SelectedSchool = this.dialogConfig.data.SelectedSchool;
		this.SchoolName = this.SelectedSchool.SchoolName;

		if (this.EditMode == true) {
			this.SelectedTopic = this.dialogConfig.data.SelectedTopic;
			this.TopicCD = this.SelectedTopic.TopicCD;
			this.TopicDesc = this.SelectedTopic.TopicDesc;
		}
	}

	/////////////////////////////////////////////////////////////////////
	// Data
	/////////////////////////////////////////////////////////////////////

	EditMode: boolean = false;

	SelectedSchool: any;
	SelectedTopic: any;

	TopicCD: string = "";
	TopicDesc: string = "";
	SchoolName: string = "";

	Processing: boolean = false;
	ErrorMessage: string = "";

	/////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////
	// Buttons
	/////////////////////////////////////////////////////////////////////

	onAdd() {
		this.ErrorMessage = "";

		if (this.TopicCD == undefined || this.TopicCD.trim().length == 0) {
			this.ErrorMessage = "Enter name of the topic/group to notify";
			return;
		}
		if (this.TopicDesc == undefined || this.TopicDesc.trim().length == 0) {
			this.ErrorMessage = "Enter description of the group";
			return;
		}

		var parms: PanicAlertTopicRequest = {
			PortalPanicAlertTopicID: -1,
			SchoolID: this.SelectedSchool.SchoolID,
			TopicCD: this.TopicCD,
			TopicDesc: this.TopicDesc,
			lstPersonID: [],
		};

		this.Processing = true;

		var result = this.dataService.PanicAlertTopicInsert(parms);
		result.subscribe(
			(response: any) => {
				if (response.Success == true) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "topicmodify",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Topic was added successfully.",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "topicmodify",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not add the Topic: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}

				this.Processing = false;
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onUpdate() {
		this.ErrorMessage = "";

		if (this.TopicCD == undefined || this.TopicCD.trim().length == 0) {
			this.ErrorMessage = "Enter name of the topic/group to notify";
			return;
		}
		if (this.TopicDesc == undefined || this.TopicDesc.trim().length == 0) {
			this.ErrorMessage = "Enter description of the group";
			return;
		}

		var parms: PanicAlertTopicRequest = {
			PortalPanicAlertTopicID: this.SelectedTopic.PortalPanicAlertTopicID,
			SchoolID: -1,
			TopicCD: this.TopicCD,
			TopicDesc: this.TopicDesc,
			lstPersonID: [],
		};

		this.Processing = true;

		var result = this.dataService.PanicAlertTopicUpdate(parms);
		result.subscribe(
			(response: any) => {
				if (response.Success == true) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "topicmodify",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Topic was updated successfully.",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "topicmodify",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not update the Topic: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}

				this.Processing = false;
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onClose() {
		this.ref.close(0);
	}

	/////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////
	// Events
	/////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////
}
